import './App.scss';
import React, {useState, useEffect} from 'react';
import {Routes, Route, BrowserRouter} from 'react-router-dom';
import Faq from './components/Faq';

function AppContent() {
    const [scrolling, setScrolling] = useState(false);
    const [isHovered, setIsHovered] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 0) {
                setScrolling(true);
            } else {
                setScrolling(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const handleMouseEnter = () => {
        setIsHovered(true);
    };

    const handleMouseLeave = () => {
        setIsHovered(false);
    };

    const handleLinkClickToTerms = () => {
        window.open('https://aicleanup.topmusetech.com/user-agreement/terms_of_use.pdf', '_blank');
    };

    const handleLinkClickToPrivate = () => {
        window.open('https://aicleanup.topmusetech.com/user-agreement/privacy_notice.pdf', '_blank');
    };

    const handleLocateToAppStore = () => {
        window.open('https://apps.apple.com/us/app/fitmeal-health-fitness-recipe/id6504800448', '_blank');
    };

    return (
        <div className="App">
            <header className={scrolling ? "header header-scrolled" : "header"}>
                <div className='container'>
                    <div className='navL'>
                        <img src="./nav_logo.png" alt="" style={{width: '210px'}}/>
                    </div>
                    <div className='navR'>
                        <div
                            onMouseEnter={handleMouseEnter}
                            onMouseLeave={handleMouseLeave}
                            style={{backgroundColor: isHovered ? '#3860D2' : '#3860D2'}}
                            className='download'>
                            Download
                            {isHovered && (
                                <div className='qrCode'>
                                    <div className='triangle'>
                                        <img src="./triangle.png" alt=""/>
                                    </div>
                                    <div className='qrcode'>
                                        <img src="./qrcode.png" alt=""/>
                                    </div>
                                    <div className='text'>
                                        <div>
                                            <img src="./scan.png" alt=""/>
                                        </div>
                                        <div>Scan to download</div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </header>
            <div className='section'>
                <div className='left'>
                    <img src="./left.png" alt=""/>
                </div>
                <div className='right'>
                    <div className='icon'>
                        <img src="./icon.png" alt=""/>
                    </div>
                    <div className='name'>AI Cleanup</div>
                    <div className='desc'>Afraid of losing precious photos during cleanups ？—— AI Cleaner makes deletion
                        worry-free. Intelligently clean unwanted photos while carefully safeguarding your precious
                        memories. Trust us to handle it with care.
                    </div>
                </div>
            </div>
            <footer className='footer'>
                <div className='container'>
                    <div className='footerL'>
                        <div className='title'>Cleanai</div>
                        <div className='copyright'>2024 © Topmuse Pte Ltd. All Rights Reserved.</div>
                    </div>
                    <div className='footerR'>
                        <div className='item'>
                            <div className='link'
                                 onClick={handleLinkClickToPrivate}
                            >Privacy Policy
                            </div>
                        </div>
                        <div className='item'>
                            <div className='link'
                                 onClick={handleLinkClickToTerms}
                            >Terms of Use
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
}

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<AppContent/>}/>
                <Route path="/faq" element={<Faq/>}/>
            </Routes>
        </BrowserRouter>
    );
}

export default App;
